module.exports = __webpack_public_path__ + "img/07.ac042699.png";